<div class="upload" [dataSelector]="'cxp-crl-panel-file-upload'">
  <!-- Dropzone shows only while the item is still editable (open / overdue /
       changes-requested). In review + done states it is hidden — the client must
       Undo "I'm Finished" to add more files. -->
  @if (canUpload()) {
    <awn-upload-files
      type="drag"
      [multiple]="true"
      [disabled]="isSubmitting()"
      [entityData]="entityData()"
    ></awn-upload-files>
  }

  <!-- Dedicated replace uploader: visually hidden, opened programmatically when
       the container triggers Replace. Its single-call submission-file-replace-stream
       endpoint uploads the replacement AND supersedes/versions the flagged
       original server-side in one request. -->
  <awn-upload-files
    type="hidden"
    [multiple]="false"
    [entityData]="replaceEntityData()"
    [triggerFileSelection$]="replacePicker$"
    (onFileUploadEnd)="onReplaceUploadEnd($event)"
    [dataSelector]="'cxp-crl-panel-file-replace'"
  ></awn-upload-files>
</div>
